export default "__VITE_ASSET__2hUB2UPQ67PWoKFr6F4a1w__";